'use strict';
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_string-repeat.js
 ** module id = 94
 ** module chunks = 0 1
 **/